export default "__VITE_ASSET__DFRSVXWe__"